<template>
  <div class="completion-status-table">
    <div class="btn">
      <el-button type="primary" size="small" @click="resendSurvey">通知未填写学生尽快填写</el-button>
    </div>
    <el-table :data="completionList" max-height="450">
      <el-table-column property="studentName" label="姓名" width="150"></el-table-column>
      <el-table-column property="completionStatus" label="填写状态">
        <template slot-scope="scope">
          {{ scope.row.completionStatus == "1" ? "已完成" : "未完成" }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <div class="operate">
            <el-button type="success" size="small" @click="detailClick(scope.row)"
              v-if="scope.row.completionStatus == '1'">详情
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页容器 -->
    <div class="pagination-catainer">
      <pagination :pageSize="parseInt(pageSize)" @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange" :total="parseInt(total)" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["completionList", "total", "pageSize", "pageNum", "surveyTableData"],
  data() {
    return {
    };
  },
  methods: {
    detailClick(row) {
      this.$emit("detailClick", row);
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.$emit("currentPageNumChange", pageNum);
    },
    handleSizeChange(pageSize) {
      this.$emit("handleSizeChange", pageSize);
    },
    // 消息再次推送
    resendSurvey() {
      this.get(this.$url.resendSurveyData + "/" + this.surveyTableData.id).then(res=> {
        if (res.code == 200) {
          this.$message.success("通知成功");
        } else {
          this.$message.error("通知失败");
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./completionStatusTable.scss";
</style>